import updateActions from '../redux/reducers/UpdateChecker';
import type {
  SWUpdateDbVersions,
  SWUpdateInstalledVersions,
  SWUpdateQtObject,
  SWUpdateState,
  SWUpdateStore,
  SWUpdateVersions,
} from './types/SWUpdateApi';

export type {
  SWUpdateDbVersions,
  SWUpdateInstalledVersions,
  SWUpdateQtObject,
  SWUpdateState,
  SWUpdateStateValue,
  SWUpdateStore,
  SWUpdateTask,
  SWUpdateVersionTuple,
  SWUpdateVersions,
} from './types/SWUpdateApi';

export class SWUpdateApi {
  private qtobject: SWUpdateQtObject | null = null;

  connect(qtobject: SWUpdateQtObject | null, store: SWUpdateStore): void {
    // connecting all machine actions here
    this.qtobject = qtobject;
    try {
      if (qtobject) {
        qtobject.swupdate_state.connect((state: string) => {
          store.dispatch(
            updateActions.setSWupdateState(JSON.parse(state) as SWUpdateState)
          );
        });
      }
    } catch (e) {
      console.log(e);
    }
    try {
      if (qtobject) {
        qtobject.sw_versions.connect((state: string) => {
          store.dispatch(
            updateActions.setVersions(
              JSON.parse(state) as SWUpdateInstalledVersions
            )
          );
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  approve_download(): void {
    this.qtobject!.approve_download();
  }
  start_update(): void {
    this.qtobject!.start_update();
  }
  check_files(versions: SWUpdateVersions): void {
    if (this.qtobject) {
      this.qtobject.check_files(JSON.stringify(versions));
    }
  }
  check_files_manual(versions: SWUpdateVersions): void {
    if (this.qtobject) {
      this.qtobject.check_files_manual(JSON.stringify(versions));
    }
  }
  check_my_innovatint_com(): void {
    if (this.qtobject) {
      this.qtobject.check_my_innovatint_com();
    }
  }
  check_my_innovatint_com_manual(): void {
    if (this.qtobject) {
      this.qtobject.check_my_innovatint_com_manual();
    }
  }
  set_db_versions(params: SWUpdateDbVersions): void {
    if (this.qtobject) {
      this.qtobject.set_db_versions(JSON.stringify(params));
    }
  }

  get_sw_versions(): void {
    if (this.qtobject) {
      try {
        this.qtobject.get_sw_versions();
      } catch (e) {
        console.log(e);
      }
    }
  }
}
const api = new SWUpdateApi();

export { api as default };
